module.exports = __webpack_public_path__ + "1af077a65ce8e4e59fca51b986ca91e6.svg";